/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccountSummary {
    getFixupPrototypeFunction() { return AccountSummary.fixupPrototype; }

    static newInstance(model: Partial<AccountSummary>): AccountSummary {
        let obj = Object.assign(new AccountSummary(), model);
        AccountSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccountSummary>): AccountSummary {
        if (!model) return null;
        return AccountSummary.newInstance(<AccountSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccountSummary) {
        if (!obj) return;

        models.AccountSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccountSummary): boolean {
        Object.setPrototypeOf(obj, AccountSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.estimated_cost === undefined) {
            this.estimated_cost = 0;
        }
        if (this.monthly_cost_savings === undefined) {
            this.monthly_cost_savings = 0;
        }
        if (this.quarterly_cost_savings === undefined) {
            this.quarterly_cost_savings = 0;
        }
        if (this.yearly_cost_savings === undefined) {
            this.yearly_cost_savings = 0;
        }
        if (this.impacted_resources === undefined) {
            this.impacted_resources = 0;
        }
    }

    /**
     * Cloud account id
     */
    cloud_account_id: string;

    /**
     * Cloud account name
     */
    cloud_account_name: string;

    /**
     * Cloud account type
     */
    cloud_account_type: string;

    /**
     * Recommendations
     */
    recommendation: string;

    /**
     * Estimated cost
     */
    estimated_cost: number;

    /**
     * Monthly cost savings
     */
    monthly_cost_savings: number;

    /**
     * Quarterly cost savings
     */
    quarterly_cost_savings: number;

    /**
     * Yearly cost savings
     */
    yearly_cost_savings: number;

    /**
     * Impacted resources
     */
    impacted_resources: number;

    /**
     * Savings percentage
     */
    savings_percentage: string;

    /**
     * Monthly cost saving information
     */
    monthly_cost_saving_info: string;

    /**
     * Quarterly cost saving information
     */
    quarterly_cost_saving_info: string;

    /**
     * Yearly cost saving information
     */
    yearly_cost_saving_info: string;

}
